
import React from "react";

const getValue = (row, accessor) => {
    if (!accessor) return "";
    if (accessor.includes(".")) {
        return accessor.split(".").reduce((acc, key) => acc?.[key], row);
    }
    return row[accessor];
};

const TableRenderer = ({ columns = [], data = [], layout = "horizontal", actions = [] }) => {
    if (!data || data.length === 0) return <p>No data available</p>;

    return (
        <table className={`custom-att-table ${layout === "horizontal" ? "horizontal-table" : "vertical-table"}`}>
            {layout === "horizontal" ? (
                <>
                    <thead>
                        <tr>
                            {columns.map((col, i) => <th key={i}>{col.header}</th>)}
                            {actions?.length > 0 && <th>Actions</th>}
                        </tr>
                    </thead>

                    <tbody>
                        {data.map((row, rIndex) => (
                            <tr key={rIndex}>
                                {columns.map((col, cIndex) => {
                                    const raw = getValue(row, col.accessor);
                                    return (
                                        <td key={cIndex} className={col.className || ""}>
                                            {typeof col.render === "function" ? col.render(raw, row) : (raw ?? "-")}
                                        </td>
                                    );
                                })}

                                <td>
                                    {actions.map((action, aIndex) => {
                                        if (action.show && !action.show(row)) return null;
                                        return (
                                            <button
                                                key={aIndex}
                                                className="text-button"
                                                onClick={() => action.onClick && action.onClick(row)}
                                                style={{ marginRight: 8 }}
                                            >
                                                {action.label}
                                            </button>
                                        );
                                    })}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </>
            ) : (
                <tbody>
                    {columns.map((col, idx) => {
                        const value = getValue(data[0], col.accessor);
                        return (
                            <tr key={idx}>
                                <th>{col.header}</th>
                                <td>{typeof col.render === "function" ? col.render(value, data[0]) : (value ?? "-")}</td>
                            </tr>
                        );
                    })}
                </tbody>
            )}
        </table>
    );
};

export default TableRenderer;
